import _ from 'lodash'

class QuotationVisitorNewsletter {
    /** @ngInject */
    constructor(DeviceChecker, ContractDraft, CampaignLanding, CampaignLandingType, ErrorCatcher) {
        this.isMobile = DeviceChecker.isMobile
        this.contractDraftService = ContractDraft
        this.CampaignLanding = CampaignLanding
        this.CampaignLandingType = CampaignLandingType
        this.ErrorCatcher = ErrorCatcher
        this.newsletterForm = { email: null }
    }

    displayForm() {
        this.onDispatch({ $event: { type: 'DISPLAY_NEWSLETTER_FORM' } })
    }

    submitFormNewsletter() {
        this.onDispatch({ $event: { type: 'SUBMIT_NEWSLETTER_FORM' } })
        this.CampaignLanding.submitCampaignInformation({
            id_campaign: 'LANDING_NEWSLETTER',
            type: this.CampaignLandingType.SUBSCRIBE,
            referrer: _.isEmpty(document.referrer) ? undefined : document.referrer,
            mail: this.newsletterForm.email,
        }).$promise.then(() => {
            this.onDispatch({ $event: { type: 'SUBMIT_NEWSLETTER_FORM_DONE' } })
        }).catch((error) => {
            this.ErrorCatcher.catchError(error)
            this.onDispatch({ $event: { type: 'SUBMIT_NEWSLETTER_FORM_ERROR' } })
        })
    }

    displayFirstAdvice() {
        this.onDispatch({ $event: { type: 'DISPLAY_FIRST_ADVICE' } })
    }
}

export default {
    template: require('./quotationVisitorNewsletter.jade')(),
    controller: QuotationVisitorNewsletter,
    bindings: {
        store: '<',
        onDispatch: '&',
    },
}



// WEBPACK FOOTER //
// ./src/states/quotation/component/quotationVisitorNewsletter.js